/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { Datatable } from '../../../../components/Datatable/Datatable'
import type { MetaType } from '../../../../components/Datatable/Datatable'
import { Button } from '../../../../components/Button/Button'
import { Loading } from '../../../../components/Loading/Loading'
import useModals from '../../../../hooks/useModals'
import { useNavigate } from 'react-router-dom'
import { DELETE, POST } from '../../../../services/api'
import Swal from 'sweetalert2'
import { ModalDelete } from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import { getPlugintypeIdByCode } from '../../../../functions/plugintype'
import useAuth from '../../../../hooks/useAuth'
import { i18n } from '../../../../translate/i18n'
import { BreadCrumbs } from '../../../../components/BreadCrumbs/breadCrumbrs'
import usePluginsSpace from '../../../../hooks/usePluginSpace'
import { ModalWrapper } from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import { Input } from '../../../../components/Input/Input'

type IntegrationType = {
  id: number
  name: string
  type: string
  templateType: string
  typeId: number
}

type IntegrationResponseType = {
  id: number
  name: string
  plugintemplateId: {
    id: number
    name: string
    parameters: string
    plugintypeId: number
    typeIntegration: string
  }
}

const MensageriaContent: FC = () => {
  const { showDeleteModal, showWrapperModal, closeWrapperModal } = useModals()
  const { loginInfo } = useAuth()
  const { getPluginConfigs, metaPluginConfigs, getIntegrations } = usePluginsSpace()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [integrations, setIntegrations] = useState<Array<IntegrationType>>([])
  const [id, setId] = useState<number | null>(null)
  const [meta, setMeta] = useState<MetaType | undefined>(undefined)
  const [email, setEmail] = useState<string>('')

  const getIntegrationsMensageria = async (take: number = 10, page: number = 1) => {
    try {
      setLoading(true)
      await getIntegrations(true, false)
      const integrationRes = await getPluginConfigs(true, false)
      const newIntegrations: IntegrationType[] = integrationRes.map(
        (pluginconfig: IntegrationResponseType) => {
          return {
            id: pluginconfig.id,
            name: pluginconfig.name,
            type: pluginconfig.plugintemplateId.name,
            typeId: pluginconfig.plugintemplateId.plugintypeId,
            templateType: pluginconfig.plugintemplateId.typeIntegration,
          }
        }
      )
      let integrationsGet: IntegrationType[] = []
      const plugincode = getPlugintypeIdByCode(loginInfo.plugintype)
      newIntegrations.forEach((integration) => {
        if (
          integration.templateType === 'messenger' &&
          (integration.typeId === plugincode || integration.typeId === 1)
        ) {
          integrationsGet.push(integration)
        }
      })
      setIntegrations(integrationsGet)
      setMeta(metaPluginConfigs)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const deleteIntegration = async () => {
    try {
      setLoading(true)
      const integrationRes = await DELETE(`/pluginconfig/${id}`)
      if (integrationRes.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Integração deletada',
          text: 'Deleção realizada com sucesso!',
        }).then(async () => await getIntegrationsMensageria())
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao deletar integração!',
        }).then(async () => await getIntegrationsMensageria())
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao deletar integração!',
      }).then(async () => await getIntegrationsMensageria())
      console.log(e)
    }
  }

  useEffect(() => {
    getIntegrationsMensageria()
  }, [])

  const testEmail = async () => {
    try {
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Por favor, insira um e-mail válido!',
            customClass: {
              popup: 'swal2-custom-zindex',
            },
            })
          return
        }

      const payload = {
        email: email,
      }
      setLoading(true)
      const response = await POST(`/email/send_email_test`, payload)
      setLoading(false)
      if (response.success) {
        setEmail('')
        closeWrapperModal()
        Swal.fire({
          icon: 'success',
          title: 'Sucesso',
          text: 'Email enviado com sucesso, verifique sua caixa de mensagem!',
        }) 
      }

    } catch (e: any) {
      setLoading(false)
      setEmail('')
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e ? e : 'Erro ao enviar email  teste!',
      })
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`integration.messenger`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(
                    `integration.listed_here_are_the_integrations_along_with_their_respective_actions`
                  )}
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text={i18n.t(`buttons.add_integration`)}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/pluginconfig/messenger/create')}
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <Datatable
                data={integrations}
                headers={[
                  { key: i18n.t(`integration.integration_name`), value: 'name', type: 'default' },
                  { key: i18n.t(`integration.type_of_integration`), value: 'type', type: 'default' },
                  { key: i18n.t(`general.actions`), value: 'acoes', type: '' },
                ]}
                options={[
                  {
                    icon: 'fas fa-pen',
                    action: (item) => {
                      navigate(`/pluginconfig/messenger/edit/${item.id}`)
                    },
                    title: `${i18n.t(`general.edit`)} ${i18n.t(`integration.messenger`)}`,
                  },
                  {
                    icon: 'fas fa-trash',
                    action: (item) => {
                      showDeleteModal(
                        `${i18n.t(`general.delete`)} ${i18n.t(`integration.messenger`)}`
                      )
                      setId(item.id)
                    },
                    title: `${i18n.t(`general.delete`)} ${i18n.t(`integration.messenger`)}`,
                  },
                  {
                    icon: 'fa fa-play',
                    action: async (item) => {
                      showWrapperModal(`${i18n.t(`general.test`)} ${i18n.t(`integration.integration`)}`)
                    },
                    title: `${i18n.t(`general.test`)} ${i18n.t(`integration.integration`)}`,
                    verifyConditionItem: 'type',
                    verifyConditionValue: (value: string) => ['E-mail SMTP Próprio'].includes(value),
                  }
                ]}
                color='primary'
              />
            </div>
          </div>
          <ModalDelete confirmAction={() => deleteIntegration()} />
          <ModalWrapper
            noCloseOverlay={false}
            noCloseButton
            noAction
           zIndex={1000}
            confirmAction={() => { }}
          >
            <div className='w-100 d-flex flex-column'>
              <div className='w-100 d-flex flex-column mt-2 gap-2'>
                <div className='d-flex flex-column gap-2'>
                  <p className='text-dark   fs-6 mt-6'>
                  Para testar a integração, preencha o e-mail abaixo para teste
                  </p>
                  <Input
                    value={email}
                    grow
                    placeholder='Digite o e-mail'
                    change={(value: string) => setEmail(value)}
                    inputAttr={{
                      type: 'email',
                    }}

                  />

                </div>
              </div>
              <div className='w-100 d-flex flex-row justify-content-end'>
                <button
                  onClick={email ?testEmail :closeWrapperModal}
                  className='btn btn-small fw-bolder mt-4'
                  style={{ backgroundColor: '#6E7586', color: '#FFF' }}
                >
                  <p style={{ fontSize: 14, marginBottom: 0 }}>
                    {email ? i18n.t(`general.test`) : i18n.t(`buttons.close`)}
                  </p>
                </button>
              </div>
            </div>

          </ModalWrapper>
        </div>
      )}
    </>
  )
}

const Mensageria: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: true },
          { title: i18n.t(`integration.messenger`), path: 'pluginconfig/messenger', isActive: true },
        ]}
      >
        {i18n.t(`integration.messenger`)}
      </PageTitle>
      <MensageriaContent />
    </>
  )
}

export { Mensageria }
